<template>
  <div class="main-container">
    <div class="header center">
      个人历史实验
    </div>
    <div class="main">
      <el-table
        :data="experiment"
        border
        size="small"
        header-cell-class-name="my-header"
        style="width: 100%;border-radius: 8px"
      >
        <el-table-column
          prop="student.schoolName"
          align="center"
          width="80px"
          show-overflow-tooltip
          label="实验ID"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.id }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="student.realName"
          align="center"
          show-overflow-tooltip
          label="姓名"
        >
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="创建时间">
          <template slot-scope="scope">
            <span>
              {{
                scope.row.createTime
                  ? new Date(scope.row.createTime).$Format("yyyy/MM/dd hh:mm")
                  : "-"
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="提交时间">
          <template slot-scope="scope">
            <span>
              {{
                scope.row.submitTime
                  ? new Date(scope.row.submitTime).$Format("yyyy/MM/dd hh:mm")
                  : "-"
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1" style="color:red">
              实验中
            </span>
            <span v-else-if="scope.row.status === 2" style="color: #0c63e8">
              待评价
            </span>
            <span v-else-if="scope.row.status === 3" style="color: #42b983">
              已评价
            </span>
            <span v-else-if="scope.row.status === 4">
              已取消
            </span>
            <span v-else>
              出错
            </span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          width="100px"
          show-overflow-tooltip
          label="系统评分"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.systemScore }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          width="100px"
          show-overflow-tooltip
          label="教师评分"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.score ? scope.row.score : "-" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="date" width="100px" align="center" label="操作">
          <template slot-scope="scope">
            <div class="handle-wrap">
              <img
                src="@/assets/image/jixu.png"
                alt=""
                style="cursor:pointer;"
                @click="
                  $router.push({
                    path: '/data/source',
                    query: { id: scope.row.id },
                  })
                "
                v-if="scope.row.status === 1"
              />
              <img
                src="@/assets/image/wancheng.png"
                alt=""
                style="height: 32px;cursor: pointer"
                v-else-if="scope.row.status === 3"
                @click="evaluate(scope.row)"
              />
              <img
                src="@/assets/image/daipingjia.png"
                alt=""
                style="height: 32px;cursor:pointer;"
                v-else-if="scope.row.status === 2"
                @click="evaluate(scope.row)"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <el-pagination
          :page-count="5"
          :current-page="searchParams.pagination.pageNo"
          @current-change="
            (index) => {
              searchParams.pagination.pageNo = index;
              getList();
            }
          "
          :total="searchParams.pagination.total"
          class="tea-pagination"
          prev-text="上一页"
          next-text="下一页"
          layout="prev, pager, next"
        >
        </el-pagination>
      </div>
    </div>
    <div class="give-a-mark" v-if="giveAMarkActive">
      <div class="give-a-make-wrap">
        <transition
          appear-to-class="animate__animated animate__fadeInLeft"
          appear
        >
          <div class="mark-view">
            <div class="product-result" v-if="showProductHidReport">
              <div class="header">
                <div class="nav-item active">
                  <div class="txt">
                    实验结果
                  </div>
                </div>
                <div
                  class="nav-item "
                  @click="showProductHidReport = !showProductHidReport"
                >
                  <div class="txt">
                    实验报告
                  </div>
                </div>
              </div>
              <div class="content">
                <div
                  class="item"
                  v-for="(item, index) in evaluateData.templates"
                  :key="index"
                >
                  <el-row :gutter="10" v-if="item.product">
                    <el-col :span="8">
                      <div class="item-product-img">
                        <div class="img">
                          <img :src="item.main" alt="" />
                        </div>
                        <div class="country">
                          <img
                            v-if="item.product.country === '马来西亚'"
                            src="@/assets/image/analysis/nalaixiya.png"
                            alt=""
                          />
                          <img
                            v-else-if="item.product.country === '越南'"
                            src="@/assets/image/analysis/yuenan.png"
                            alt=""
                          />
                          <img
                            v-else-if="item.product.country === '泰国'"
                            src="@/assets/image/analysis/taiguo.png"
                            alt=""
                          />
                          <img v-else src="@/assets/image/country.png" alt="" />
                          <div class="text">{{ item.product.country }}</div>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="item-product-info">
                        <div
                          class="info--item"
                          style="width: 340px;margin-bottom: 30px"
                        >
                          <div class="label">
                            标题
                          </div>
                          <div
                            class="value"
                            style="height: 73px;font-size: 14px;padding: 10px;line-height:16px"
                          >
                            {{ item.product.title }}
                          </div>
                        </div>
                        <div style="width: 340px;display: flex">
                          <div
                            class="info--item"
                            style="width: 160px;margin-right: 19px"
                          >
                            <div class="label">
                              价格¥
                            </div>
                            <div
                              class="value center"
                              style="height: 54px;font-size: 24px;color:#616466"
                            >
                              {{ item.product.price }}
                            </div>
                          </div>
                          <div class="info--item" style="width: 160px">
                            <div class="label">
                              库存kg
                            </div>
                            <div
                              class="value center"
                              style="height: 54px;font-size: 24px;color:#616466"
                            >
                              {{ item.product.stock }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="item-product-info">
                        <div
                          class="info--item"
                          style="width: 340px;margin-bottom: 30px"
                        >
                          <div class="label">
                            描述
                          </div>
                          <div
                            class="value"
                            style="height: 182px;font-size: 14px;padding:10px;color:#616466;line-height:16px"
                          >
                            {{ item.product.description }}
                          </div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <div class="report-result" v-else>
              <div class="header">
                <div
                  class="nav-item "
                  @click="showProductHidReport = !showProductHidReport"
                >
                  <div class="txt">
                    实验结果
                  </div>
                </div>
                <div class="nav-item active">
                  <div class="txt">
                    实验报告
                  </div>
                </div>
              </div>
              <div class="content">
                <div class="main">
                  <div class="view-box" style="margin-right: 120px;">
                    <div class="title">
                      <div class="icon">
                        <img src="@/assets/image/result/1.png" alt="" />
                      </div>
                      <div class="name">
                        <div class="txt">
                          实验目的
                        </div>
                        <div class="sub-txt">
                          experiment objective
                        </div>
                      </div>
                    </div>
                    <div class="content">
                      <textarea
                        v-model="formatterContent.objective"
                        disabled
                      ></textarea>
                    </div>
                  </div>
                  <div class="view-box">
                    <div class="title">
                      <div class="icon">
                        <img src="@/assets/image/result/2.png" alt="" />
                      </div>
                      <div class="name">
                        <div class="txt">
                          实验总结
                        </div>
                        <div class="sub-txt">
                          experiment summary
                        </div>
                      </div>
                    </div>
                    <div class="content">
                      <textarea v-model="formatterContent.result" disabled>
                      </textarea>
                    </div>
                  </div>
                </div>
                <div class="foot" style="text-align: center">
                  <button class="submitbtn" v-print="'#printSection'">
                    <i class="el-icon-printer"></i>
                    <span>
                      打印报告
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </transition>
        <transition
          appear-to-class="animate__animated animate__fadeInRight"
          appear
        >
          <div class="user-wrap">
            <div class="title">
              <h3>
                基本信息
              </h3>
              <p>
                essential information
              </p>
            </div>
            <div class="content">
              <div class="item">
                <div class="icon">
                  <img src="@/assets/image/home/user-user.png" alt="" />
                </div>
                <div class="txt">
                  <p>
                    姓名
                  </p>
                  <p>
                    {{ evaluateData.student.realName }}
                  </p>
                </div>
              </div>
              <div class="item">
                <div class="icon">
                  <img src="@/assets/image/home/user-no.png" alt="" />
                </div>
                <div class="txt">
                  <p>
                    学号
                  </p>
                  <p>
                    {{ evaluateData.student.studentNo }}
                  </p>
                </div>
              </div>
              <div class="item">
                <div class="icon">
                  <img src="@/assets/image/home/user-school.png" alt="" />
                </div>
                <div class="txt">
                  <p>
                    学校
                  </p>
                  <p>
                    {{ evaluateData.student.schoolName }}
                  </p>
                </div>
              </div>
              <div class="item">
                <div class="icon">
                  <img src="@/assets/image/home/user-class.png" alt="" />
                </div>
                <div class="txt">
                  <p>
                    班级
                  </p>
                  <p>
                    {{ evaluateData.student.className }}
                  </p>
                </div>
              </div>
            </div>
            <div class="foot">
              <button @click="evaluateActive = true">
                <div>
                  评价 evaluate
                </div>
              </button>
            </div>
          </div>
        </transition>
        <transition
          appear-to-class="animate__animated animate__fadeInRight animate__delay-500ms"
          appear
        >
          <div class="close-view" @click="giveAMarkActive = false">
            <i class="el-icon-close"></i>
          </div>
        </transition>
      </div>
      <el-dialog
        append-to-body
        class="add-modal modal-title"
        title="提示"
        :visible.sync="evaluateActive"
        @open="isBlur(true)"
        @close="isBlur(false)"
        width="734px"
      >
        <div slot="title" class="title">
          <div class="text">
            实验评分
          </div>
          <div class="sub-text">
            Experimental score
          </div>
        </div>
        <div>
          <el-form label-position="top" :model="registerData" ref="register">
            <el-form-item label="姓名">
              <el-input
                v-model="evaluateData.student.realName"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="评分">
              <div style="display: flex">
                <div style="width: 80%">
                  <el-slider
                    disabled
                    v-model="teacherEvaluate.score"
                    input-size="large"
                  ></el-slider>
                </div>
                <div
                  style="width: 20%;font-family: fantasy;font-size: 28px;display: flex;align-items: center;justify-content: center"
                >
                  {{ teacherEvaluate.score }}
                </div>
              </div>
            </el-form-item>
            <el-form-item label="教师评语">
              <el-input
                v-model="teacherEvaluate.markNote"
                type="textarea"
                :rows="8"
                disabled
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
    </div>
    <table
      id="printSection"
      style="position: absolute;z-index: -99;left: 0;top: 0;"
    >
      <tr style="height: 200px">
        <td colspan="2">
          <div class="tit">
            <h1>实验报告</h1>
            <h3>电商选品虚拟仿真实验</h3>
            <div class="student">
              <span>姓名 : {{ evaluateData.student.realName }}</span>
              <span>学号 : {{ evaluateData.student.studentNo }}</span>
              <span>学校 : {{ evaluateData.student.schoolName }}</span>
              <span>班级 : {{ evaluateData.student.className }}</span>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td style="width: 2rem">
          <div class="cell strong">
            实验目的
          </div>
        </td>
        <td>
          <div class="cell left">
            <pre v-html="formatterContent.objective"></pre>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="cell strong">
            实验总结
          </div>
        </td>
        <td>
          <div class="cell left">
            <pre v-html="formatterContent.result"></pre>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      experiment: [],
      searchParams: {
        pagination: {
          total: 0,
          pageNo: 1,
          pageSize: 10,
        },
      },
      registerData: {
        userName: "",
        password: "",
        password2: "",
        realName: "",
        studentNo: "",
        className: "",
        schoolName: "",
      },
      teacherEvaluate: {
        id: "",
        score: 0,
        markNote: "",
      },
      evaluateData: {
        student: {},
      },
      giveAMarkActive: false,
      evaluateActive: false,
      showProductHidReport: true,
      score: 0,
    };
  },
  created() {
    this.getList();
  },
  computed: {
    formatterContent() {
      return this.evaluateData.content
        ? JSON.parse(this.evaluateData.content)
        : {};
    },
  },
  methods: {
    getList() {
      this.$axios
        .post("/student/experiment/list", this.searchParams)
        .then((res) => {
          if (res.succeed) {
            this.experiment = res.items;
            this.searchParams.pagination.total = res.pagination.total;
          }
        });
    },
    isBlur(type) {
      switch (type) {
        case true:
          document.querySelector("#app").classList.add("blur");
          break;
        case false:
          document.querySelector("#app").classList.remove("blur");
          break;
      }
    },
    evaluate(data) {
      this.showProductHidReport = true;
      this.giveAMarkActive = true;
      this.evaluateData = data;
      this.teacherEvaluate.id = data.id;
      this.teacherEvaluate.score = data.score;
      this.teacherEvaluate.markNote = data.markNote;
    },
  },
};
</script>

<style scoped lang="scss">
.main-container {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  min-width: 300px;
  background: #ffffff;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  border-radius: 12px;
  .header {
    display: flex;
    height: 96px;
    line-height: 96px;
    background: linear-gradient(360deg, #005be7 0%, #70a0eb 100%);
    opacity: 1;
    border-radius: 12px 12px 0px 0px;
    font-size: 30px;
    font-weight: 400;
    color: #ffffff;
    padding: 0 20%;
    &.center {
      justify-content: center;
    }
    div.nav-item {
      cursor: pointer;
      width: 50%;
      text-align: center;

      div.txt {
        padding: 0 20px;
        display: inline-block;
        height: 96px;
        position: relative;
        font-weight: 400;
      }

      &.active {
        .txt {
          font-weight: bold;
        }

        .txt:before {
          content: "";
          position: absolute;
          bottom: 1px;
          left: 0;
          width: 100%;
          height: 8px;
          background: white;
        }
      }
    }
  }
  .main {
    border-radius: 12px;
    height: calc(100% - 96px);
    padding: 24px 30px;
    ::v-deep .my-header {
      background: #70a0eb;
      font-size: 18px;
      font-family: Microsoft YaHei UI, serif;
      font-weight: 400;
      color: #ffffff;
    }
    ::v-deep .el-table--small {
      font-size: 14px;
    }

    .pagination-wrap {
      margin-top: 30px;
    }

    .handle-wrap {
      position: relative;
      width: 80px;
      height: 32px;
      img {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        margin: auto;
        z-index: 999;
        height: 40px;
      }
    }
  }
}
.give-a-mark {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  background: rgba(0, 0, 0, 0.6);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  animation: toShow 0.2s linear both;

  @keyframes toShow {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .give-a-make-wrap {
    min-width: 1600px;
    height: 900px;
    display: flex;
  }

  .mark-view {
    width: 1200px;
    margin-right: 40px;

    .product-result {
      > .content {
        min-height: 806px;
        padding: 28px 62px;
        background: white;
        border-radius: 0 0 12px 12px;

        .item {
          margin-bottom: 18px;

          &:last-child {
            margin-bottom: 0;
          }

          .item-product-img {
            height: 230px;
            display: flex;

            .img {
              border: 1px solid #e4e4e4;
              border-radius: 12px 0 0 12px;
              overflow: hidden;
              border-right: none;

              img {
                width: 230px;
                height: 100%;
                object-fit: cover;
              }
            }

            .country {
              width: 110px;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              border: 1px solid #e4e4e4;
              border-radius: 0 12px 12px 0;

              img {
                width: 90px;
              }

              .text {
                font-size: 22px;
                font-family: Microsoft YaHei UI, serif;
                font-weight: 400;
                line-height: 28px;
                color: #999999;
              }
            }
          }

          .item-product-info {
            .info--item {
              .label {
                font-size: 14px;
                font-family: Microsoft YaHei UI, serif;
                font-weight: 400;
                line-height: 18px;
                color: #999999;
                margin-bottom: 8px;
              }

              .value {
                background: #ffffff;
                border: 2px solid #f1f1f1;
                opacity: 1;
                border-radius: 12px;
                overflow-y: auto;

                &.center {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                }
              }
            }
          }
        }
      }
    }

    .report-result {
      > .content {
        min-height: 806px;
        padding: 28px 62px;
        background: white;
        border-radius: 0 0 12px 12px;
        .main {
          display: flex;
          justify-content: center;

          .view-box {
            padding-top: 76px;
            display: flex;
            justify-content: center;
            flex-direction: column;

            .title {
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-bottom: 18px;

              .icon {
                width: 90px;
                height: 90px;
                background: linear-gradient(142deg, #70a0eb 0%, #005be7 100%);
                box-shadow: 0px 3px 6px rgba(0, 91, 231, 0.3);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 10px;
              }

              .name {
                text-align: center;

                .txt {
                  font-size: 22px;
                  font-weight: bold;
                  line-height: 29px;
                  color: #333333;
                }

                .sub-txt {
                  font-size: 12px;
                  font-weight: 400;
                  line-height: 29px;
                  color: #999999;
                }
              }
            }

            .content {
              textarea {
                resize: none;
                width: 440px;
                height: 280px;
                background: #ffffff;
                border: 2px solid #f1f1f1;
                opacity: 1;
                border-radius: 12px;
                padding: 18px;
                font-size: 14px;
                font-family: "Microsoft YaHei", sans-serif;
              }
            }
          }
        }
      }
    }
  }

  .user-wrap {
    width: 360px;
    padding: 20px 30px;
    background: #ffffff;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.16);
    opacity: 1;
    border-radius: 15px;
    display: flex;
    flex-direction: column;

    .title {
      margin-bottom: 30px;

      h3 {
        font-size: 26px;
        font-weight: bold;
        line-height: 33px;
        color: #454b60;
      }

      p {
        font-size: 12px;
        font-weight: 400;
        color: #999999;
      }
    }

    .content {
      flex: 1;

      .item {
        height: 98px;
        border: 1px solid #f1f1f1;
        opacity: 1;
        border-radius: 12px;
        padding: 20px;
        margin-bottom: 20px;

        .icon {
          float: left;
          margin-right: 30px;
        }

        .txt {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;

          p:first-child {
            font-size: 14px;
            font-weight: 400;
            line-height: 17px;
            color: #999999;
            margin-bottom: 6px;
          }

          p:last-child {
            font-size: 18px;
            font-weight: bold;
            line-height: 23px;
            color: #666666;
          }
        }
      }
    }

    .foot {
      margin-bottom: 10px;

      button {
        width: 100%;
        height: 54px;
        background: linear-gradient(
          90deg,
          rgba(119, 166, 239, 0.97) 0%,
          #005be7 100%
        );
        box-shadow: 0px 1px 4px rgba(119, 166, 239, 0.97);
        opacity: 1;
        border-radius: 60px;
        font-size: 20px;
        font-family: Microsoft YaHei UI, sans-serif;
        font-weight: 400;
        line-height: 22px;
        color: #ffffff;
        text-transform: uppercase;
      }
    }
  }

  .close-view {
    border-radius: 12px;
    margin-left: 30px;
    width: 40px;
    height: 40px;
    background: white;
    text-align: center;
    line-height: 40px;
    font-size: 20px;
    cursor: pointer;

    &:hover {
      background: #fe4a49;
      transition: all 0.3s ease-in-out;
      color: white;
    }
  }
}
.add-modal {
  .title {
    padding: 0 12px;

    .text {
      height: 33px;
      font-size: 26px;
      font-family: Microsoft YaHei UI, serif;
      font-weight: bold;
      line-height: 33px;
      color: #454b60;
    }

    .sub-text {
      height: 15px;
      font-size: 12px;
      font-family: Microsoft YaHei UI, serif;
      font-weight: 400;
      line-height: 15px;
      color: #999999;
      text-transform: uppercase;
    }
  }

  ::v-deep .el-form-item {
    width: 100%;

    &:nth-child(even) {
      margin-right: 62px;
    }

    .el-form-item__label {
      font-size: 18px;
      line-height: 18px;
    }

    .el-input__inner {
      height: 54px;
      background: #ffffff;
      border: 2px solid #f1f1f1;
      border-radius: 12px;
      line-height: 54px;
    }
  }

  ::v-deep .el-slider__runway {
    height: 36px;
  }

  ::v-deep .el-slider__bar {
    height: 36px;
  }
}
</style>
<style lang="scss">
table#printSection {
  width: 100%;
  height: 100%;
  border: 1px solid #4e6d94;

  tr {
    width: 100%;

    td {
      border-right: 1px solid #000000;
      border-bottom: 1px solid #000000;
      vertical-align: middle;

      &:last-child {
        border-right: none;
      }

      div.tit {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #4e6d93;

        h1 {
          font-weight: bold;
          font-size: 34px;
          margin-bottom: 10px;
        }

        h3 {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 10px;
        }

        div.student {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          padding-left: 160px;
          box-sizing: border-box;

          span {
            text-align: left;
            line-height: 40px;
            font-size: 16px;
            width: 50%;
          }
        }
      }

      div.cell {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;

        &.left {
          align-items: flex-start;
          justify-content: flex-start;
        }

        &.strong {
          width: 100%;
          min-width: 100px;
          font-size: 18px;
          font-weight: bolder;
        }
      }

      textarea {
        display: none;
      }
      pre {
        padding: 10px 20px;
        font-size: 14px;
        font-family: serif;
        line-height: 18px;
        white-space: pre-wrap;
        word-break: break-all;
        /*min-height: 400px;*/
      }
    }
  }
}
</style>
